import React, { useState } from 'react';

const GROUPS = [
  { id: 'tonic', label: 'Tonic' },
  { id: 'dominant', label: 'Dominant' }
];
const SLOTS = [
  { suffix: 'root', label: 'root' },
  { suffix: 'third', label: 'third' },
  { suffix: 'fifth', label: 'fifth' }
];

function displayKey(config) {
  if (config.keyLabel) return config.keyLabel;
  const key = String(config.key || 'e').replace(/#/g, '♯').replace(/b/g, '♭');
  return `${key} minor, ${config.scaleForm || 'harmonic'} form`;
}

export default function TonicDominantSpellInputs({ config, value = {}, onChange, mode, feedback }) {
  const [active, setActive] = useState(null);
  const editable = mode === 'edit';
  const change = (id, next) => {
    if (editable) onChange?.({ ...value, [id]: next });
  };

  return (
    <div style={{ ...(config.singleRow ? { display: 'grid', gridTemplateColumns: config.gridTemplateColumns || '220px repeat(3, 230px)', columnGap: config.columnGap ?? 24, alignItems: 'center', width: config.rowWidth || 982 } : { display: 'flex', alignItems: 'end', flexWrap: 'wrap', gap: '24px 36px' }), paddingBottom: editable ? (config.allowDoubleAccidentals ? 70 : 35) : 0, color: '#1f2937' }}>
      <div style={{ fontWeight: 600, alignSelf: 'center', minWidth: config.keyLabelMinWidth ?? 160 }}>{displayKey(config)}</div>
      {(config.groups || GROUPS).map(group => (
        <div key={group.id} style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'center' }}>
          {!config.hideGroupHeadings && <strong>{group.label}</strong>}
          <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
            {SLOTS.map(({ suffix, label }, index) => {
              const id = `${group.id}_${suffix}`;
              const part = feedback?.parts?.[id];
              const borderColor = mode === 'review' && part ? (part.correct ? '#2e7d32' : '#c62828') : 'currentColor';
              return (
                <React.Fragment key={id}>
                  {index > 0 && <span aria-hidden="true">–</span>}
                  <div style={{ position: 'relative' }}>
                    <input
                      aria-label={`${config.ariaLabelPrefix ? config.ariaLabelPrefix + ", " : ""}${group.label} ${label}`}
                      type="text"
                      autoCapitalize="none"
                      autoComplete="off"
                      spellCheck={false}
                      maxLength={5}
                      value={value[id] || ''}
                      disabled={!editable}
                      onFocus={() => setActive(id)}
                      onBlur={() => setActive(current => current === id ? null : current)}
                      onChange={event => change(id, event.target.value)}
                      style={{ width: 56, height: 36, textAlign: 'center', fontSize: 18, border: 'none', borderBottom: `2px solid ${borderColor}`, borderRadius: 0, outlineOffset: 2, backgroundColor: 'transparent', color: 'inherit', opacity: 1 }}
                    />
                    {active === id && editable && (
                      <div style={{ display: 'flex', flexWrap: 'wrap', width: config.allowDoubleAccidentals ? 80 : undefined, gap: 5, position: 'absolute', top: '100%', left: 0, paddingTop: 4, zIndex: 5 }}>
                        {[['♯', 'Sharp'], ['♭', 'Flat'], ...(config.allowDoubleAccidentals ? [['𝄪', 'Double sharp'], ['𝄫', 'Double flat']] : [])].map(([symbol, label]) => (
                          <button
                            key={symbol}
                            type="button"
                            aria-label={`Insert ${label.toLowerCase()} in ${config.ariaLabelPrefix ? config.ariaLabelPrefix + ", " : ""}${group.label.toLowerCase()} ${suffix}`}
                            tabIndex={-1}
                            onMouseDown={event => event.preventDefault()}
                            onClick={() => change(id, (value[id] || '').replace(/^([A-Ga-g])(?:[#b♯♭]|𝄪|𝄫)*$/, '$1') + symbol)}
                            style={{ padding: '2px 6px', fontSize: 17, cursor: 'pointer' }}
                          >{symbol}</button>
                        ))}
                      </div>
                    )}
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
